import React, { useState, useEffect } from "react"
import ReactPaginate from "react-paginate";
import { Col, Row } from "reactstrap"
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"

export const LedgerDetail = ({ sortedLedgerUpdationList, ledgerUpdationList, ledgerUpdationPage, handleLedgerUpdationPageClick }) => {


    const {
        txnDecimalAmt
    } = useContext(Context);

    const iddexOfLastPostLedgerUpdation = ledgerUpdationPage * 10
    const iddexOfFirstPostLedgerUpdation = iddexOfLastPostLedgerUpdation - 10
    const currentDetailRowsLedgerUpdation = sortedLedgerUpdationList.slice(iddexOfFirstPostLedgerUpdation, iddexOfLastPostLedgerUpdation)

    return (
        <div>
            <Row>
                <Col sm={12} md={12} className="mb-4-sm">
                    <table className="custom-table table-bordered table-sm rounded">
                        <thead className='table-secondary'>
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center' , fontWeight: 'bold'  }}>
                                    Ledger Updation Details
                                </th>
                            </tr>
                            <tr style={{ height: '40px' }}>
                                <td style={{ fontWeight: 'bold' }}> # </td>
                                <td onClick={() => {
                                    setSortBy('date')
                                }} style={{ cursor: 'pointer', fontWeight: 'bold' }}>Date</td>
                                <td>Account</td>
                                <td style={{ textAlign: "right", fontWeight: 'bold' }}>Debit</td>
                                <td style={{ textAlign: "right", fontWeight: 'bold' }}>Credit</td>
                                <td onClick={() => {
                                    setSortBy('doucmentNo')
                                }} style={{ cursor: 'pointer', fontWeight: 'bold' }}>Document #</td>
                                <td style={{ fontWeight: 'bold' }}>Reference #</td>
                                <td style={{ fontWeight: 'bold' }}>Remarks & A/C Description</td>
                                <td style={{ fontWeight: 'bold' }}>Reference # (2)</td>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDetailRowsLedgerUpdation.map((item, index) => (
                                <tr key={index}>
                                    <td>{iddexOfFirstPostLedgerUpdation + index + 1}</td>
                                    <td>{item.date.slice(0, 10)}</td>
                                    <td>{item.account}</td>
                                    <td style={{ textAlign: "right" }}>{Math.abs(parseFloat(item.debit).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                        maximumFractionDigits: txnDecimalAmt,
                                        minimumFractionDigits: 2,
                                    })}</td>
                                    <td style={{ textAlign: "right" }}>{Math.abs(parseFloat(item.credit).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                        maximumFractionDigits: txnDecimalAmt,
                                        minimumFractionDigits: 2,
                                    })}</td>
                                    <td>{item.doucmentNo}</td>
                                    <td>{item.reference1}</td>
                                    <td>{item.remarks}</td>
                                    <td>{item.reference2}</td>
                                </tr>
                            ))}
                        </tbody>
                        {ledgerUpdationList.length > 0 ? <tfoot>
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}> {Math.abs(ledgerUpdationList.reduce((a, b) => +a + +(b.debit), 0).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                    maximumFractionDigits: txnDecimalAmt,
                                    minimumFractionDigits: 2,
                                })}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}> {Math.abs(ledgerUpdationList.reduce((a, b) => +a + +(b.credit), 0).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                    maximumFractionDigits: txnDecimalAmt,
                                    minimumFractionDigits: 2,
                                })}</td>
                            </tr>
                        </tfoot> : null}
                    </table>
                </Col>
            </Row>
            <Row>
                <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(ledgerUpdationList.length / 10)}
                    pageRangeDisplayed={1}
                    onPageChange={handleLedgerUpdationPageClick}
                    forcePage={ledgerUpdationPage - 1}
                    renderOnZeroPageCount={null}
                    activeClassName={'active'}
                    activeLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-end pagination-sm'}
                    marginPagesDisplayed={1}

                />
            </Row>
        </div>
    )

}